import { render } from "./FridgeDetailsSettingsHelpDialog.vue?vue&type=template&id=a1256b76&scoped=true&ts=true"
import script from "./FridgeDetailsSettingsHelpDialog.vue?vue&type=script&lang=ts"
export * from "./FridgeDetailsSettingsHelpDialog.vue?vue&type=script&lang=ts"

import "./FridgeDetailsSettingsHelpDialog.vue?vue&type=style&index=0&id=a1256b76&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1256b76"]])

export default __exports__